export default __webpack_public_path__ + "static/media/HomeHameburger.ba827f67.svg";